import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import PanelHeader from '@/components/layouts/panel/panel-header'
import PanelContent from '@/components/layouts/panel/panel-content'
import EconomicAssetTable from './economicAsset-table'
import Loader from '@/modules/base/components/loader/loader'

const useStyles = makeStyles(theme => ({
  economicAssetContent: {
    padding: 0,
    backgroundColor: theme.backgroundColor,
    height: '100%',
  },
  headerLabel: {
    order: -1,
    paddingLeft: 30,
    fontSize: 20,
    color: theme.black,
    whiteSpace: 'nowrap',
    display: 'flex',
    maxWidth: 394,
    flexDirection: 'column',
  },
  previewHeader: {
    backgroundColor: theme.backgroundColor,
    height: 79,
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingRight: 15,
  },
  previewWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}))

const EconomicAssetTablePreview = (props) => {
  const classes = useStyles(props)
  const {
    data,
    depreciationMethod,
    costOfPurchase,
    economicLife,
    economicAssetData,
    number,
    description,
    dateOfPurchase,
    periodType,
    specialDepreciationData,
    isSpecialDepreciation,
    possibleDepreciationMethods,
    isGWG,
    isLoading,
    onHeaderClick,
  } = props
  return (
    <div className={classes.previewWrapper}>
      <PanelHeader className={classes.previewHeader}>
        <div className={classes.headerLabel}>
          <span>{lang.economicAsset.preview.title}</span>
        </div>
      </PanelHeader>
      <PanelContent>
        <div className={classes.economicAssetContent}>
          <Loader customClass={classes.loader} visible={isLoading} text={lang.generics.loading} />
          <EconomicAssetTable
            economicData={data}
            depreciationMethod={depreciationMethod}
            costOfPurchase={costOfPurchase}
            economicLife={economicLife}
            economicAssetData={economicAssetData}
            number={number}
            description={description}
            dateOfPurchase={dateOfPurchase}
            periodType={periodType}
            specialDepreciationData={specialDepreciationData}
            isSpecialDepreciation={isSpecialDepreciation}
            isGWG={isGWG}
            possibleDepreciationMethods={possibleDepreciationMethods}
            onHeaderClick={onHeaderClick}
          />
        </div>
      </PanelContent>
    </div>
  )
}

EconomicAssetTablePreview.propTypes = {
  data: PropTypes.array.isRequired,
  depreciationMethod: PropTypes.string.isRequired,
  costOfPurchase: PropTypes.number.isRequired,
  economicLife: PropTypes.string.isRequired,
  economicAssetData: PropTypes.array.isRequired,
  number: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  dateOfPurchase: PropTypes.string.isRequired,
  periodType: PropTypes.string.isRequired,
}

export default EconomicAssetTablePreview
